var _UseAnalyticsWrapper;
import React, { useEffect, memo } from 'react';
import hasDom from 'has-dom';
import _isEqual from 'lodash/isEqual';
import { Google } from 'reaxl-analytics-handlers';
import Context from './context/Context';
import { useDelayedPageReadyEvent } from './analyticsEventDispatcher/index.js';
import { handlePostMessage } from './utilities/index.js';
import useEventBusAnalytics from './hooks/useEventBusAnalytics';
import useAnalyticsListener from './hooks/useAnalyticsListener';
import { jsx as _jsx } from "react/jsx-runtime";
const {
  Provider
} = Context;
const noop = () => ({});
function UseAnalyticsWrapper() {
  useAnalyticsListener();
  return null;
}

/*
 * Context to set analytics handlers for the app
 */
export const AnalyticsEngine = /*#__PURE__*/memo(props => {
  const {
    dataLayer,
    getDataIsland,
    google = {},
    value: events = {},
    option = {},
    hooks = {},
    disabled = false,
    history = {},
    eventListener
  } = props;

  // provide agnostic event listener support to existing history usages
  if (eventListener) {
    history.eventListener = eventListener;
  }

  // TODO: all apps should pass dataLayer function instead of object
  const getDataLayer = typeof dataLayer === 'function' ? dataLayer : () => dataLayer;
  useEffect(() => {
    // set initial Google Configuration
    Google.setGoogleConfiguration(google);
    const onPostMessage = event => handlePostMessage({
      history
    }, event, option);
    if (hasDom()) {
      // set a global variable so we can tell if things are handled through reaxl-analytics or not in Launch
      window.reaxlAnalytics = true;

      // initialize dataLayer for GA
      window.dataLayer = window.dataLayer || [];
      if (!option?.disablePostMessage) {
        // add a postMessageHandler
        window.addEventListener('message', onPostMessage, false);
      }
    }
    return () => {
      // remove postMessageHandler on unmount
      window.removeEventListener('message', onPostMessage, false);
    };
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);
  useEventBusAnalytics({
    history
  }, getDataLayer, option);
  const data = {
    dataLayer: getDataLayer,
    dataIsland: getDataIsland,
    events,
    option,
    hooks: {
      useDevice: noop,
      useDataIsland: noop,
      ...hooks
    },
    disabled,
    history
  };
  useDelayedPageReadyEvent(data);
  return /*#__PURE__*/_jsx(Provider, {
    value: data,
    children: _UseAnalyticsWrapper || (_UseAnalyticsWrapper = /*#__PURE__*/_jsx(UseAnalyticsWrapper, {}))
  });
}, (prev, next) => {
  if (typeof prev.dataLayer === 'function') {
    // if dataLayer is a function, we'll re-render reaxl-analytics Provider when the page gets new instance id
    // so that we also re-render useAnalytics to be able to get the latest dataLayer
    return prev.instanceId === next.instanceId && _isEqual(prev.history, next.history) && _isEqual(prev.eventListener, next.eventListener) && _isEqual(prev.dataIsland, next.dataIsland);
  }
  return _isEqual(prev.dataLayer, next.dataLayer) && _isEqual(prev.history, next.history) && _isEqual(prev.eventListener, next.eventListener);
});